<template lang='pug'>
  b-nav-item-dropdown(right='', no-caret='')
    template(slot='button-content')
      i.icon-list
      b-badge(pill='', variant='warning') {{itemsCount}}
    b-dropdown-header.dropdown-menu-lg.text-center(tag='div')
      strong You have {{itemsCount}} pending tasks
    b-dropdown-item
      .small.mb-1
        | Upgrade NPM & Bower
        span.float-right
          strong 0%
      b-progress.progress-xs(height='{}', variant='info', :value='0')
    b-dropdown-item
      .small.mb-1
        | ReactJS Version
        span.float-right
          strong 25%
      b-progress.progress-xs(height='{}', variant='danger', :value='25')
    b-dropdown-item
      .small.mb-1
        | VueJS Version
        span.float-right
          strong 50%
      b-progress.progress-xs(height='{}', variant='warning', :value='50')
    b-dropdown-item
      .small.mb-1
        | Add new layouts
        span.float-right
          strong 75%
      b-progress.progress-xs(height='{}', variant='info', :value='75')
    b-dropdown-item
      .small.mb-1
        | Angular 2 Cli Version
        span.float-right
          strong 100%
      b-progress.progress-xs(height='{}', variant='success', :value='100')
    b-dropdown-item.text-center
      strong View all tasks
</template>
<script>
  export default {
    name: 'header-dropdown-tasks',
    data: () => {
      return { itemsCount: 15 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownTasks.vue